import React from "react";
import { useEffect, useContext, useState } from "react";
import { GamePlayerContext, LocalPlayerContext } from "../../game/context/game-context";
import { AuthBasicContext } from "../context/authBasic.context";
import { AuthBasicService } from "../service/authBasic.service";

export function InitiateProvider({ children }) {
  const authBasicService = AuthBasicService();
  const [isInitialized, setIsInitialized] = useState(false);

  const updateLocalPlayerSetting = LocalPlayerContext((state) => state.updateLocalPlayerSetting);

  const getLocalPlayerSetting = GamePlayerContext((state) => state.getLocalPlayerSetting);

  const setGamePlayerContext = GamePlayerContext(
    (state) => state.setGamePlayerContext
  );

  useEffect(() => {
    const initialize = async () => {
      const checkAuth = await authBasicService.initialize();
      if (checkAuth) {
        updateLocalPlayerSetting(checkAuth);
        setGamePlayerContext({
          isAccountBinded: checkAuth.isAccountBinded,
          isProfileUpdated: true,
        });
      } else {
        // check if there any local storage skin
        const getLocalePlayerSetting = localStorage.getItem("local_player_setting");
        if (getLocalePlayerSetting) {
          updateLocalPlayerSetting(JSON.parse(getLocalePlayerSetting))
          setGamePlayerContext({
            isProfileUpdated: true,
          });
        }
      }
      setIsInitialized(true);
    };

    initialize();
  }, []);

  return <AuthBasicContext.Provider value={{ ...authBasicService }}>
    {isInitialized && children}
  </AuthBasicContext.Provider>
}

export const useAuthBasicService = () => React.useContext(AuthBasicContext);
